export default __webpack_public_path__ + "static/media/m_ticket.f7eb9621.svg";